export const RulesConstants = {
  Parameters: {
    UserAffiliate: 'userAffiliate',
    PageAffiliate: 'pageAffiliate',
    Operator: 'operator',
    Conditions: 'conditions',
  },
  Operators: {
    And: 'AND',
    Or: 'OR',
  },
};
